import React, { Component } from 'react';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Button} from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import StepOne from '../art/images/step1.png';
import StepTwo from '../art/images/step2.png';
import betaLogo from '../images/alumsumlogotm.png';
import './onboarding.css';
import Footer from '../Footer';

class Onboarding extends Component{
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) {
        super(props);
        const {cookies} = props;
        this.state = {
            loading: false,
            error: null,
            csrfToken: cookies.get('XSRF-TOKEN')
        };
    }
    render(){
        return(
            <div>

                {/* <img src={Group} alt = "group" className="responsive"/> */}
                <Link to="/"><img src={betaLogo} alt="logo" className="responsiveLogo"/></Link>


                <div className="alumsum-is-your-one1">
                    <div className="alumsum-is-your-one2">
                        <h3 className="alumsum-welcome"><strong>Welcome to AlumSum! </strong></h3>
                        <p></p>
                        <p></p>
                        <p>
                            AlumSum is your one stop shop for all things related to your student loan experience. Get
                            ready to take control of your debt, shorten your payoff timeline, and save money.
                        </p>
                    </div>
                    <div className="alumsum-is-your-one3">
                        <p>Let's get your account set up in a few steps: </p>
                    </div>
                </div>
                <div className="step-outer-box">
                    <div className="step1">
                        <p>Step 1</p>
                        <div className="Rectangle">
                            <div className="step1text">
                                <p> First, you'll tell us a bit about your personal info.</p>
                            </div>

                            <div className="stepoval">
                                <img src={StepOne} alt = "step one" className="responsive"/>
                            </div>
                        </div>
                    </div>
                    <div className="step1Mobile">
                        <div className="Rectangle">
                            <p className="mobileStep">Step 1</p>
                            <div>
                                <div className="stepoval">
                                    <img src={StepOne} alt = "step one" className="responsive"/>
                                </div>
                                <div className="step1text">
                                    <p> First, you'll tell us a bit about your personal info.</p>
                                </div> 
                            </div> 
                        </div>
                    </div>

                    <div className="step1">
                        <p>Step 2</p>
                        <div className="Rectangle">
                            
                            <div className="step2text">
                                <p>Then you'll add your loans.</p>
                            </div>

                            <div className="stepoval">
                                <img src={StepTwo} alt = "step two" className="responsive"/>
                            </div>

                        </div>
                    </div>
                    <div className="step1Mobile">
                        <div className="Rectangle">
                            <p className="mobileStep">Step 2</p>
                            <div>
                                <div className="stepoval">
                                    <img src={StepTwo} alt = "step two" className="responsive"/>
                                </div>
                                <div className="step1text">
                                    <p>Then you'll add your loans.</p>
                                </div>
                            </div>
                        </div>
                    </div>     
                </div>
                <div className="getStartedBox">
                    <Button color="success"  className="getStarted" href="/alumsum/onboardingprofile">Get Started</Button>
                </div>
                <Footer/>
            </div>

        );
    }
}

export default withCookies(withRouter(Onboarding));